import { FC } from 'react';
import Button from '../../../../ui/button/button';
import { BUTTON_VARIANTS } from '../../../../constants/button-variants';
import translation from '../../../../languages';
import './cart-fetch-error.scss';

export type CartFetchErrorProps = TranslationProps & {
    onRetry: VoidFunction;
};

const CartFetchError: FC<CartFetchErrorProps> = ({ onRetry, t }) => (
    <div className='cart-fetch-error'>
        <p>{t('cart.errors.fetchFailed')}</p>
        <Button variant={BUTTON_VARIANTS.YELLOW} onClick={onRetry}>
            {t('cart.errors.retry')}
        </Button>
    </div>
);

const translate = translation('cart');

export default translate(CartFetchError);
